export default __webpack_public_path__ + "static/media/01-ART-(3-2).0cd3aad1.jpg";